import {useRef} from "react";
import "./index.css";



function NavMenu(){

	let overlay_for_nav = useRef();
	let actual_nav = useRef();

	function slideMenu(event){
		event.preventDefault();
		overlay_for_nav.current.classList.toggle("out");
		actual_nav.current.classList.toggle("out");
	}

	function takeMenuOut(){
		overlay_for_nav.current.classList.remove("out");
		actual_nav.current.classList.remove("out");	
	}

	return(
		<div id="nav-house">

			<div className="flexed">
				<div className="iconic unit vibrate">
					<a href="#contact-me"> <i className="fas fa-envelope-square"></i> </a>
				</div>

				<div className="iconic unit">
					<a href="/" onClick={event=>slideMenu(event)}> <i className="fas fa-bars"></i> </a>
				</div>


			</div>

			<div className='nav-overlay' ref={overlay_for_nav} onClick={()=>takeMenuOut()} > </div>
			<nav ref={actual_nav}>
				<a className="arts" href="#my-about"> About Me </a>
				<a className="arts" href="#can-do"> What I Can Do For You! </a>
				<a className="arts" href="#previous-work"> My Previous Works </a>
				<a className="arts" href="#contact-me"> Leave Me A Message </a>
				<a className="arts" href="#social-media"> My Social Media </a>
				<a className="arts" href="/blog/"> My Blog </a>
				<a className="arts" href="/service/"> My Freelancing Services </a>
				<a className="arts" href="https://www.fiverr.com/share/V7dRaz" target="_blank" rel="noreferrer" > My Fiverr Gigs </a>
			</nav>

		</div>		


		)
};

export default NavMenu;

/*
<div className='points'>
	<a href="#my-about"> About Me </a>
	<a href="#can-do"> What I can do for you! </a>
	<a href="#previous-work"> My previous works </a>
	<a href="#contact-me"> Contact me now </a>
	<a href="#social-media"> My social media </a>
	<a href="/blog/"> My Blog </a>
	<a href="/service/"> My Freelancing Services </a>
</div>
*/